/**
 * @fileOverView
 * @description PersonMeter Model<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandModel = require('ampersand-model');
var app = require("ampersand-app");

//a cap of 0 on the wire means the plan has no limit (see lib/meter.js wireCap)
function capDisplay(cap){
    return (cap === 0 || cap === null || cap === undefined) ? 'no limit' : cap;
}

//monthly-cap copy where the wire cap does not tell the whole story: Platinum's
//monthly count is unmetered in the app but billed as overage
var MONTHLY_PLAN_COPY = {
    platinum: {details: '36k then $5/5k auto-added and billed', meter: '36k, $5/5k automated'}
};

function monthlyPlanCopy(tierName, where){
    var copy = tierName && MONTHLY_PLAN_COPY[tierName.toLowerCase()];
    return copy ? copy[where] : null;
}

var Meter = AmpersandModel.extend({

    idAttribute: 'key',

    urlRoot: function(){
        return app.config.restApiUrl + "/meter";
    },

    ajaxConfig: app.utils.setAuthTokenHeader,

    props: {
        personKey: 'string',
        tier_id: 'number',
        number_vybits: 'number',
        count_daily: 'number',
        count_monthly: 'number',
        last_log_dts: 'string',
        monthly_reset_dts: 'string',
        paid_thru_dts: 'string',
        cap_vybits: 'number',
        cap_daily: 'number',
        cap_monthly: 'number',
        //org seat cap, plan name, and plan prices for this plan, from the tier
        //table (seats 0 = unlimited; prices in cents, null = not sold)
        seats: 'number',
        tier_name: 'string',
        price_monthly: 'number',
        price_yearly: 'number',
        frac_daily: 'string',
        frac_monthly: 'string',
        warn_daily_sent: 'boolean',
        warn_monthly_sent: 'boolean',
        err_daily_sent: 'boolean',
        err_monthly_sent: 'boolean',
        err_payment_sent: 'boolean',
        warn_payment_sent: 'boolean',
        current_time: 'string',
        customer_id: 'string',
        session_url: 'string'
    },

    session: {
      name: ['string', true, ''],
      email: ['string', true, '']
    },

    derived: {

        plan: {
            deps: ['tier_name'],
            fn: function () {
                return this.tier_name ? this.tier_name.toUpperCase() : "NONE";
            }
        },

        plansLink: {
            deps: ['tier_id'],
            fn: function () {
                return app.utils.externalLinkHtml(app.utils.wwwUrl('/pricing'), 'See plans');
            }
        },

        //plan-details copy on my.vybit.net
        orgSeatsDetail: {
            deps: ['seats'],
            fn: function () {
                var seats = app.utils.orgSeatCap(this.seats);
                return 'Manager seats: ' + (seats === Infinity ? 'unlimited' : seats) + '.';
            }
        },

        linkedPlan: {
            deps: ['plan'],
            fn: function(){

                link = `<a href="https://${app.config.pwHost}?pk=${this.personKey}" target="_blank" onclick="app.utils.cancelBubble()">${this.plan}</a>`;

                if(app.platform == "app") link = `<a href="javascript:void(0)" onclick='cordova.InAppBrowser.open("https://${app.config.pwHost}?pk=${this.personKey}", "_system");'>${this.plan}</a>`;

                return link;
            }
        },

        //plan-details copy on the subscription page
        capVybitsDisplay: {
            deps: ['cap_vybits'],
            fn: function () { return capDisplay(this.cap_vybits); }
        },

        capDailyDisplay: {
            deps: ['cap_daily'],
            fn: function () { return capDisplay(this.cap_daily); }
        },

        capMonthlyDisplay: {
            deps: ['cap_monthly', 'tier_name'],
            fn: function () {
                return monthlyPlanCopy(this.tier_name, 'details') || capDisplay(this.cap_monthly);
            }
        },

        vybits: {
            deps: ['cap_vybits'],
            fn: function () {
                return (app.vybs?.length || 0) + " / " + capDisplay(this.cap_vybits);
            }
        },

        daily_count: {
            deps: ['count_daily'],
            fn: function(){
                return this.count_daily + " / " + capDisplay(this.cap_daily);
            }
        },

        daily_reset: {
            deps: ['last_log_dts'],
            fn: function(){
                const now = new Date()
                const nextMidnightUTC = new Date(now.getTime() + (86400000 - ((new Date()).getTime() % 86400000)));
                const timeString = nextMidnightUTC.toLocaleTimeString([], { hour: 'numeric' });
                const timeParts = timeString.split(' ');
                const formattedTime = `${timeParts[0].replace(/^0+/, '')} ${timeParts[1]}`;
                return 'resets at ' + formattedTime;
            }
        },

        monthly_count: {
            deps: ['count_monthly', 'tier_name'],
            fn: function(){
                return this.count_monthly + " / " + (monthlyPlanCopy(this.tier_name, 'meter') || capDisplay(this.cap_monthly));
            }
        },

        monthly_reset: {
            deps: ['monthly_reset_dts'],
            fn: function(){
                const date = new Date(this.monthly_reset_dts);
                const formattedDate = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

                return 'resets on ' + formattedDate;
            }
        }
    }
});

module.exports = Meter;
